(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldCheckboxList', ['thfFieldHelper', '$sce',function(thfFieldHelper, $sce) {
        var link = function(scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');
        };
        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '=',
                'disabled': '='
            },
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/checkboxList.html');
            }
        };
    }]);
})(jQuery, angular, window);
